export default __webpack_public_path__ + "static/media/googleplay.d3ee4a9f.svg";